import { render } from "./apiKeys.vue?vue&type=template&id=5653f0bb&scoped=true"
import script from "./apiKeys.vue?vue&type=script&lang=js"
export * from "./apiKeys.vue?vue&type=script&lang=js"

import "./apiKeys.vue?vue&type=style&index=0&id=5653f0bb&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5653f0bb"]])

export default __exports__